 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"fail":"fail","lang-en-US":"lang-en-US","lang-en-US-setting":"lang-en-US-setting","lang-vi":"lang-vi","lang-vi-setting":"lang-vi-setting","user":"user"}[chunkId]||chunkId) + "." + {"chunk-09d6dff3":"1e818c66","chunk-0b5730fc":"9b95a4d6","chunk-0bd69fa0":"f310eda9","chunk-109e4a0e":"43a44a47","chunk-125d9736":"bb1b219b","chunk-17f70de9":"0904b848","chunk-18743bef":"02ca6d5f","chunk-19e448bb":"10e23a57","chunk-1a324f0c":"b7dffe34","chunk-1b247cbd":"4b8adb5c","chunk-1b6beab1":"f8a34cf9","chunk-1bc8f52c":"7ea20f06","chunk-1ce26ccc":"790482a7","chunk-20452b85":"43458f6b","chunk-208c2446":"7763d953","chunk-21ca5f48":"231678db","chunk-2349b137":"74a8c2d7","chunk-28466fc8":"310ba27b","chunk-2a54b88e":"68733a85","chunk-2d0b345c":"3dac8bdc","chunk-2d0bce05":"f893c1fb","chunk-2d0c77ad":"67eced1a","chunk-2d0c8f6d":"d8280bde","chunk-2d0c91d2":"cbfffb4f","chunk-2d0cb6e8":"499c7315","chunk-2d0cbb33":"243c3448","chunk-2d0d0818":"c5c456b3","chunk-2d0da2ea":"47d298a4","chunk-2d0da6a8":"592fb384","chunk-2d0dace4":"0d9353e9","chunk-2d0e95df":"23e0c0d1","chunk-2d0e9d6e":"d7d9d667","chunk-2d210c28":"8edd6078","chunk-2d212fd8":"6ca9e6c5","chunk-2d217361":"2533b69e","chunk-2d2253ae":"4035e586","chunk-2ecfd031":"56490411","chunk-24b425c8":"616f0fdc","chunk-2b02de32":"20ca6dad","chunk-7f881edd":"08a6a22e","chunk-303254b2":"b8d19625","chunk-347ebcac":"032214bb","chunk-354b2aa8":"1426bf4a","chunk-35a579a2":"ff422790","chunk-398cbac2":"1c3f7291","chunk-3b7d8115":"ef31cb77","chunk-3d675996":"1c4dbb51","chunk-3dbd8674":"048245b9","chunk-44a3da96":"385c41d9","chunk-4553975f":"4cc4eb9d","chunk-49117393":"c2e75908","chunk-4b380372":"b86bd86c","chunk-4b8b91e4":"90991afe","chunk-4d17f324":"834145f0","chunk-4d36cfbd":"f92ae76b","chunk-500f1185":"2de1b7d8","chunk-507148a8":"c2971400","chunk-51bf7232":"538314de","chunk-545326c0":"41dc0eb0","chunk-54f07aba":"c2ba23ce","chunk-56cc7a73":"9c00c66f","chunk-56dec1a4":"15e95ff5","chunk-5a84305a":"824f9208","chunk-5fd9ef88":"40aa1a3d","chunk-609e28f6":"0ea08919","chunk-646bac48":"5c5378dc","chunk-66173c80":"9340ed1f","chunk-66ab3fd1":"d0d79d2a","chunk-67147130":"86d26339","chunk-67db813b":"9137e3e8","chunk-6ac44d3d":"4e357ae8","chunk-6cd8d239":"6b720279","chunk-4dc0318a":"2c5197da","chunk-c154174a":"6e830533","chunk-6d7092e8":"c9b0146e","chunk-6e6dcf96":"9197e35c","chunk-6f384fdc":"23019f36","chunk-6f5955ca":"9f510dd9","chunk-00357acc":"e5a0c583","chunk-17d2ea76":"1eed3f39","chunk-2d20918a":"49090cd4","chunk-31e3aaf3":"6e28d3e3","chunk-3635a07f":"a752552d","chunk-4b330e93":"63823f2e","chunk-4e2546e6":"0cee2a9d","chunk-540eb546":"9965b3f1","chunk-59d91b22":"b22acc79","chunk-844aa964":"f7db4adf","chunk-8f099ab8":"96937de8","chunk-9fe4383e":"730d4c88","chunk-b92141c0":"89c2365f","chunk-dd2b1d46":"53aaba6a","chunk-6f60227b":"5a5b6793","chunk-70e35ebc":"9b82c2de","chunk-7256b844":"79452f68","chunk-72addada":"8243a313","chunk-73e9d5f2":"88b6308a","chunk-744c292d":"1250e86a","chunk-7459c046":"15b887e4","chunk-7a585770":"93b724c3","chunk-7e16cd9d":"69009aa3","chunk-7ed8b0ce":"4b2c7741","chunk-7f66c91b":"5038a11a","chunk-7f706172":"dacd9bd3","chunk-8039543e":"4ed444f9","chunk-8094f028":"0a03d521","chunk-982b6af2":"4ffb53be","chunk-99bcc778":"0081d3cd","chunk-9ac5abb0":"478f0c0b","chunk-9dcfc230":"bd33c0d3","chunk-9eba3760":"18acdd47","chunk-a39ff88a":"10a036d6","chunk-a46f779c":"b0565477","chunk-ac7c3ac8":"2e36a540","chunk-adc2bb66":"e2e00a19","chunk-b81bcb8a":"388df4b0","chunk-bb042eec":"ee5cfb6a","chunk-bb9055bc":"74cbcb55","chunk-bfb322dc":"ab767a9b","chunk-c6b29aa4":"37810b36","chunk-ca4f0720":"cc67d849","chunk-cf78b932":"6267e40a","chunk-d2175d8a":"10990bab","chunk-e1a6d904":"44ecdfc8","chunk-e2b49012":"5a9f9371","chunk-ed77b080":"973fb40a","chunk-faf9c3f6":"b8f2dddf","fail":"83b8b7f4","lang-en-US":"46fcb424","lang-en-US-setting":"fcce41ed","lang-vi":"d31eeaf9","lang-vi-setting":"8f8c24a9","user":"b051c1a3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0b5730fc":1,"chunk-0bd69fa0":1,"chunk-17f70de9":1,"chunk-18743bef":1,"chunk-19e448bb":1,"chunk-1b6beab1":1,"chunk-1ce26ccc":1,"chunk-21ca5f48":1,"chunk-24b425c8":1,"chunk-354b2aa8":1,"chunk-398cbac2":1,"chunk-4b8b91e4":1,"chunk-4d36cfbd":1,"chunk-54f07aba":1,"chunk-56cc7a73":1,"chunk-56dec1a4":1,"chunk-609e28f6":1,"chunk-66ab3fd1":1,"chunk-6cd8d239":1,"chunk-4dc0318a":1,"chunk-c154174a":1,"chunk-7256b844":1,"chunk-72addada":1,"chunk-744c292d":1,"chunk-7459c046":1,"chunk-7a585770":1,"chunk-7ed8b0ce":1,"chunk-7f66c91b":1,"chunk-7f706172":1,"chunk-8039543e":1,"chunk-8094f028":1,"chunk-9dcfc230":1,"chunk-a39ff88a":1,"chunk-a46f779c":1,"chunk-bb042eec":1,"chunk-bfb322dc":1,"chunk-d2175d8a":1,"chunk-e2b49012":1,"chunk-faf9c3f6":1,"user":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"fail":"fail","lang-en-US":"lang-en-US","lang-en-US-setting":"lang-en-US-setting","lang-vi":"lang-vi","lang-vi-setting":"lang-vi-setting","user":"user"}[chunkId]||chunkId) + "." + {"chunk-09d6dff3":"31d6cfe0","chunk-0b5730fc":"0317eb89","chunk-0bd69fa0":"34d24fb6","chunk-109e4a0e":"31d6cfe0","chunk-125d9736":"31d6cfe0","chunk-17f70de9":"36b7e556","chunk-18743bef":"4f477acb","chunk-19e448bb":"03ad528b","chunk-1a324f0c":"31d6cfe0","chunk-1b247cbd":"31d6cfe0","chunk-1b6beab1":"128ba776","chunk-1bc8f52c":"31d6cfe0","chunk-1ce26ccc":"941a5711","chunk-20452b85":"31d6cfe0","chunk-208c2446":"31d6cfe0","chunk-21ca5f48":"73ead4c7","chunk-2349b137":"31d6cfe0","chunk-28466fc8":"31d6cfe0","chunk-2a54b88e":"31d6cfe0","chunk-2d0b345c":"31d6cfe0","chunk-2d0bce05":"31d6cfe0","chunk-2d0c77ad":"31d6cfe0","chunk-2d0c8f6d":"31d6cfe0","chunk-2d0c91d2":"31d6cfe0","chunk-2d0cb6e8":"31d6cfe0","chunk-2d0cbb33":"31d6cfe0","chunk-2d0d0818":"31d6cfe0","chunk-2d0da2ea":"31d6cfe0","chunk-2d0da6a8":"31d6cfe0","chunk-2d0dace4":"31d6cfe0","chunk-2d0e95df":"31d6cfe0","chunk-2d0e9d6e":"31d6cfe0","chunk-2d210c28":"31d6cfe0","chunk-2d212fd8":"31d6cfe0","chunk-2d217361":"31d6cfe0","chunk-2d2253ae":"31d6cfe0","chunk-2ecfd031":"31d6cfe0","chunk-24b425c8":"cffa522e","chunk-2b02de32":"31d6cfe0","chunk-7f881edd":"31d6cfe0","chunk-303254b2":"31d6cfe0","chunk-347ebcac":"31d6cfe0","chunk-354b2aa8":"1b938cc5","chunk-35a579a2":"31d6cfe0","chunk-398cbac2":"73ead4c7","chunk-3b7d8115":"31d6cfe0","chunk-3d675996":"31d6cfe0","chunk-3dbd8674":"31d6cfe0","chunk-44a3da96":"31d6cfe0","chunk-4553975f":"31d6cfe0","chunk-49117393":"31d6cfe0","chunk-4b380372":"31d6cfe0","chunk-4b8b91e4":"7e6ae09f","chunk-4d17f324":"31d6cfe0","chunk-4d36cfbd":"826d82f5","chunk-500f1185":"31d6cfe0","chunk-507148a8":"31d6cfe0","chunk-51bf7232":"31d6cfe0","chunk-545326c0":"31d6cfe0","chunk-54f07aba":"0e07c69f","chunk-56cc7a73":"817f0b53","chunk-56dec1a4":"8a41c503","chunk-5a84305a":"31d6cfe0","chunk-5fd9ef88":"31d6cfe0","chunk-609e28f6":"4e3f5168","chunk-646bac48":"31d6cfe0","chunk-66173c80":"31d6cfe0","chunk-66ab3fd1":"f84e2b27","chunk-67147130":"31d6cfe0","chunk-67db813b":"31d6cfe0","chunk-6ac44d3d":"31d6cfe0","chunk-6cd8d239":"5748a23b","chunk-4dc0318a":"4aa6b438","chunk-c154174a":"e3a93821","chunk-6d7092e8":"31d6cfe0","chunk-6e6dcf96":"31d6cfe0","chunk-6f384fdc":"31d6cfe0","chunk-6f5955ca":"31d6cfe0","chunk-00357acc":"31d6cfe0","chunk-17d2ea76":"31d6cfe0","chunk-2d20918a":"31d6cfe0","chunk-31e3aaf3":"31d6cfe0","chunk-3635a07f":"31d6cfe0","chunk-4b330e93":"31d6cfe0","chunk-4e2546e6":"31d6cfe0","chunk-540eb546":"31d6cfe0","chunk-59d91b22":"31d6cfe0","chunk-844aa964":"31d6cfe0","chunk-8f099ab8":"31d6cfe0","chunk-9fe4383e":"31d6cfe0","chunk-b92141c0":"31d6cfe0","chunk-dd2b1d46":"31d6cfe0","chunk-6f60227b":"31d6cfe0","chunk-70e35ebc":"31d6cfe0","chunk-7256b844":"67574022","chunk-72addada":"3f66f441","chunk-73e9d5f2":"31d6cfe0","chunk-744c292d":"3aac4123","chunk-7459c046":"3426b597","chunk-7a585770":"323a341f","chunk-7e16cd9d":"31d6cfe0","chunk-7ed8b0ce":"8a41c503","chunk-7f66c91b":"66183a72","chunk-7f706172":"11711f41","chunk-8039543e":"a60f24a6","chunk-8094f028":"d4d5710c","chunk-982b6af2":"31d6cfe0","chunk-99bcc778":"31d6cfe0","chunk-9ac5abb0":"31d6cfe0","chunk-9dcfc230":"2ffe332b","chunk-9eba3760":"31d6cfe0","chunk-a39ff88a":"f336c531","chunk-a46f779c":"7e6ae09f","chunk-ac7c3ac8":"31d6cfe0","chunk-adc2bb66":"31d6cfe0","chunk-b81bcb8a":"31d6cfe0","chunk-bb042eec":"af557729","chunk-bb9055bc":"31d6cfe0","chunk-bfb322dc":"f5944d5c","chunk-c6b29aa4":"31d6cfe0","chunk-ca4f0720":"31d6cfe0","chunk-cf78b932":"31d6cfe0","chunk-d2175d8a":"9a85fade","chunk-e1a6d904":"31d6cfe0","chunk-e2b49012":"c78a3dfe","chunk-ed77b080":"31d6cfe0","chunk-faf9c3f6":"36527024","fail":"31d6cfe0","lang-en-US":"31d6cfe0","lang-en-US-setting":"31d6cfe0","lang-vi":"31d6cfe0","lang-vi-setting":"31d6cfe0","user":"062f6374"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
